// Rozpoznawanie wiadomości pisanej zdaniami („weź jeszcze masło i 2 chleby”) zamiast listy pozycji.

// Granice słów zgodne z Unicode — \b w JS nie zna polskich liter.
const START = String.raw`(?<![\p{L}\p{N}])`;
const END = String.raw`(?![\p{L}\p{N}])`;

/** Słowa prośby — w liście pozycji się nie pojawiają (także pisane bez polskich znaków). */
const REQUEST_RE = new RegExp(
  `${START}(?:kup(?:ić|ic|isz|cie)?|we[źz](?:cie|miesz)?|jeszcze|potrzebuj(?:ę|e|emy)|potrzeba|trzeba)${END}`,
  'iu',
);
/** Początek dopisku do pozycji („lub zwykła”, „, ewentualnie …”, „i 5 bułek”) — jak ogon w parseLine. */
const TAIL_RE = new RegExp(`${START}(?:lub|albo|ewentualnie|ew|np|najlepiej|i(?=\\s+\\d))${END}`, 'iu');
const CONJUNCTION_RE = new RegExp(`${START}i${END}`, 'iu');
/** Przecinek, ale nie dziesiętny („1,5 kg”). */
const COMMA_RE = /(?<!\d),|,(?!\d)/u;
/** Nawias z uwagą (także niedomknięty na końcu linii). */
const NOTE_RE = /\([^()]*(?:\)|$)/gu;
/** Zdanie ma co najmniej tyle słów (co najmniej dwuliterowych, bez ilości i uwag). */
const MIN_WORDS = 6;

function isProseLine(line: string): boolean {
  const bare = line.replace(NOTE_RE, ' ');
  if (REQUEST_RE.test(bare)) return true;
  const tail = TAIL_RE.exec(bare);
  const head = tail ? bare.slice(0, tail.index) : bare;
  const words = head.split(/[^\p{L}\p{N}]+/u).filter((w) => /^\p{L}{2,}$/u.test(w)).length;
  return words >= MIN_WORDS && (CONJUNCTION_RE.test(head) || COMMA_RE.test(head));
}

/**
 * Czy tekst wygląda na wiadomość pisaną zdaniami, którą warto rozpisać na pozycje (AI).
 * Uwagi w nawiasach i dopiski z alternatywą nie liczą się do zdania — to zwykłe pozycje listy.
 */
export function looksLikeProse(text: string): boolean {
  return text.split(/\r\n|\r|\n/).some(isProseLine);
}
